<div class="dashboard">

    <div class="header">
        <div class="title">
            <h2 mat-title>Finances</h2>
            <!-- Categories has no card: it is a setting, not a summary of the month -->
            <a mat-icon-button routerLink="/finances/categories" title="Categories" aria-label="Categories">
                <mat-icon class="material-symbols-outlined">category</mat-icon>
            </a>
        </div>
        <app-month-picker></app-month-picker>
    </div>

    <div *ngIf="isLoading && !dashboard">Carregando...</div>

    <ng-container *ngIf="dashboard as d">
        <div class="tiles">
            <a class="tile income" routerLink="/finances/incomes">
                <span class="label">Receita</span>
                <span class="amount">R$ {{ d.summary.totals.incomes | number:'1.2-2' }}</span>
                <span class="detail" *ngIf="d.summary.dividends">inclui R$ {{ d.summary.dividends | number:'1.2-2' }} de dividendos</span>
            </a>
            <a class="tile bills" routerLink="/finances/bills">
                <span class="label">Contas</span>
                <span class="amount">R$ {{ d.summary.totals.bills | number:'1.2-2' }}</span>
                <span class="detail">{{ percent(d.summary.totals.bills) | percent:'1.2-2' }} da receita</span>
            </a>
            <a class="tile expenses" routerLink="/finances/expenses">
                <span class="label">Saídas</span>
                <span class="amount">R$ {{ d.summary.totals.expenses | number:'1.2-2' }}</span>
                <span class="detail">{{ percent(d.summary.totals.expenses) | percent:'1.2-2' }} da receita</span>
            </a>
            <div class="tile balance" [class.negative]="d.summary.totals.balance < 0">
                <span class="label">Saldo</span>
                <span class="amount">R$ {{ d.summary.totals.balance | number:'1.2-2' }}</span>
                <span class="detail">
                    {{ percent(d.summary.totals.balance) | percent:'1.2-2' }}
                    <ng-container *ngIf="invested"> · <a routerLink="/investments">R$ {{ invested | number:'1.2-2' }} investidos</a></ng-container>
                </span>
            </div>
        </div>

        <div class="section-title"><h3>Telas</h3></div>
        <div class="cards">
            @for (card of d.cards; track card.title) {
                <app-dashboard-card [card]="card"></app-dashboard-card>
            }
        </div>

        <div class="charts">
            <section class="chart">
                <h4>Saldo</h4>
                <span class="sub">Contas, saídas e o que sobrou</span>
                <div class="canvas" *ngIf="balanceChart; else noData">
                    <canvas baseChart type="pie" [data]="balanceChart" [options]="pieOptions"></canvas>
                </div>
            </section>
            <section class="chart">
                <h4>Cartões por categoria</h4>
                <span class="sub">Itens de todos os cartões no mês</span>
                <div class="canvas" *ngIf="cardsChart; else noData">
                    <canvas baseChart type="pie" [data]="cardsChart" [options]="pieOptions"></canvas>
                </div>
            </section>
            <section class="chart">
                <h4>Receita e gastos</h4>
                <span class="sub">Últimos 6 meses</span>
                <div class="canvas" *ngIf="historyChart; else noData">
                    <canvas baseChart type="bar" [data]="historyChart" [options]="barOptions"></canvas>
                </div>
            </section>
        </div>
    </ng-container>

    <ng-template #noData><p class="empty">Sem dados neste mês.</p></ng-template>
</div>
